import { render, staticRenderFns } from "./ImgEditor.vue?vue&type=template&id=3acfb8f1&scoped=true&lang=pug&"
import script from "./ImgEditor.vue?vue&type=script&lang=ts&"
export * from "./ImgEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ImgEditor.vue?vue&type=style&index=0&id=3acfb8f1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acfb8f1",
  null
  
)

component.options.__file = "ImgEditor.vue"
export default component.exports